import { Avatar, Box } from "@material-ui/core";
import { Tooltip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import filterIcon from "../../assets/Customer/Filter.svg";
import forwardIcon from "../../assets/Customer/forward.svg";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import Search from "../../components/SearchTab/Search";
import Toast from "../../components/ToastContainer/CustomToast";
import BrowserLanguage from "../../components/Util/BrowserLanguage";
import { getListSettingsById } from "../../slices/AdditionalSettings/AdditionalSettingsSlice";
import { getCustomers } from "../../slices/Customer/CustomerSlice";
import SimpleDialogDemo from "../Approvals/ImageDailogBox";
import ViewIcon from "../Invitations/ViewIcon";
import CustomerAndDealerTranscationFilter from "./CustomerAndDealerTranscationFilter";
import CustomerTransactionAndReportExports from "./CustomerTransactionAndReportExports";
import ExportDialog from "../DailyReports/ExportDialog";
import { exportHqCustomerLogs } from "../../services/Invitations/ExportDealerService";

import CommonUtil from "../../Util/CommonUtils";

let language = BrowserLanguage.getDefaultLanguage();

function CustomersTransaction() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [clear, setClear] = React.useState(false);
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [openFilter, setOpenFilter] = useState(false);
  const [openDownload, setOpenDownload] = useState(false);
  const companySettings = JSON.parse(localStorage.getItem("companySettings"));
  const history = useHistory();
  const dispatch = useDispatch();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(1);
  const [rowCustomer, setRowCustomer] = useState({});
  const companyId = localStorage.getItem("companyId");
  const [date, setDate] = useState();
  const [fileFormat, setFileFormat] = useState("1");
  const [noOfRecords, setNoOfRecords] = useState("0");
  const [inputValue, setInputValue] = useState("");
  const [toInputValue, setToInputValue] = useState("");
  const [isLivePhoto, setIsLivePhoto] = useState(false);
  const [isSignature, setIsSignature] = useState(false);
  const [closemodel, setClosemodel] = useState(false);
  const [customerTransaction, setCustomerTransaction] = useState(
    "customerTransaction"
  );

  const handleOpen = () => {
    setOpen(true);
  };

  const resetFilter = () => {
    setClear(false);
    setPaging({ ...paging, pageNumber: 1 });
    setfilter(defaultFilter);
  };

  const globalsearch = (searchedVal) => {
    const filteredRows = rows.filter((test) => {
      return (
        (test.name
          ? test.name.toLowerCase().includes(searchedVal.toLowerCase())
          : "") ||
        (test.email
          ? test.email.toLowerCase().includes(searchedVal.toLowerCase())
          : "") ||
        (test.phone
          ? test.phone.toLowerCase().includes(searchedVal.toLowerCase())
          : "") ||
        (test.subscriptionName
          ? test.subscriptionName
              .toLowerCase()
              .includes(searchedVal.toLowerCase())
          : "") ||
        (test.planBasePrice
          ? test.planBasePrice
              .toString()
              .toLowerCase()
              .includes(searchedVal.toLowerCase())
          : "") ||
        (test.billingCycle
          ? test.billingCycle.toLowerCase().includes(searchedVal.toLowerCase())
          : "") ||
        (test.dealerName
          ? test.dealerName.toLowerCase().includes(searchedVal.toLowerCase())
          : "") ||
        `${test.name}`.toLowerCase().includes(searchedVal.toLowerCase())
      );
    });
    setRows(filteredRows);
  };
  const handleChange = (newPage, size) => {
    setPage(newPage);
    setPaging({
      pageNumber: newPage,
      pageSize: size,
    });
  };

  const [defaultFilter, setDefaultFilter] = useState({
    status: "",
    name: "",
    email: "",
    subscriptionName: "",
    dealerName: "",
  });

  const [offset, setOffset] = useState("");

  useEffect(() => {
    const getLocalOffset = () => {
      const now = new Date();
      const offsetMinutes = now.getTimezoneOffset();
      const offsetHours = Math.floor(Math.abs(offsetMinutes) / 60);
      const offsetMinutesRemain = Math.abs(offsetMinutes) % 60;
      const sign = offsetMinutes > 0 ? "-" : "+";
      return `${sign}${String(offsetHours).padStart(2, "0")}:${String(
        offsetMinutesRemain
      ).padStart(2, "0")}`;
    };

    setOffset(getLocalOffset());
  }, []);

  const formatDate = (dateFormat) => {
    switch (dateFormat) {
      case "dd-MM-yyyy":
        return "dd-MM-yyyy HH:mm";
      case "MM-dd-yyyy":
        return "MM-dd-yyyy HH:mm";
      case "yyyy-MM-dd":
        return "yyyy-MM-dd HH:mm";
      default:
        return "yyyy-MM-dd HH:mm";
    }
  };

  const [filter, setfilter] = useState({
    status: "",
    name: "",
    email: "",
    subscriptionName: "",
    dealerName: "",
  });

  const [paging, setPaging] = useState({
    pageNumber: "1",
    pageSize: "10",
  });

  const handleFilter = (data) => {
    setClear(true);
    setPaging({ ...paging, pageNumber: 1 });
    setfilter({
      ...filter,
      status: data.status,
      name: data.name,
      email: data.email,
      subscriptionName: data.subscriptionName,
      dealerName: data.dealerName,
    });
  };

  const handleFileFormatChange = (event) => {
    setFileFormat(event.target.value);
  };

  const handleDataRecordsChange = (event) => {
    setNoOfRecords(event.target.value);
  };

  const handleCheckBoxLivePhoto = (event) => {
    setIsLivePhoto(event.target.checked);
  };
  const handleCheckBoxSignature = (event) => {
    setIsSignature(event.target.checked);
  };
  const handleInputChange = (event) => {
    const value = event.target.value;
    if (
      /^\d*$/.test(value) &&
      (value === "" ||
        (parseInt(value, 10) > 0 && parseInt(value, 10) <= 10000))
    ) {
      setInputValue(value);
    }
  };

  const handleToInputChange = (event) => {
    const value = event.target.value;
    if (
      /^\d*$/.test(value) &&
      (value === "" ||
        (parseInt(value, 10) > 0 && parseInt(value, 10) <= 10000))
    ) {
      setToInputValue(value);
    }
  };

  const handleExportCustomer = (data) => {
    if (fileFormat == "2") {
      setIsLivePhoto(false);
      setIsSignature(false);
    }
    var searchParam = "";
    if (filter.name !== undefined && !CommonUtil.isEmptyString(filter.name)) {
      searchParam += "&name=" + encodeURIComponent(filter.name);
    }
    if (filter.email !== undefined && !CommonUtil.isEmptyString(filter.email)) {
      searchParam += "&email=" + encodeURIComponent(filter.email);
    }
    if (
      filter.subscriptionName !== undefined &&
      !CommonUtil.isEmptyString(filter.subscriptionName)
    ) {
      searchParam +=
        "&subscriptionName=" + encodeURIComponent(filter.subscriptionName);
    }
    if (
      filter.dealerName !== undefined &&
      !CommonUtil.isEmptyString(filter.dealerName)
    ) {
      searchParam += "&dealerName=" + filter.dealerName;
    }
    searchParam += "&timeZone=" + encodeURIComponent(offset);
    searchParam +=
      "&datepattern=" + formatDate(companySettings.adminAndDealerDateFormat);
    searchParam += "&isHqTransactions=" + "isHqTransactions";

    const stats = {
      fileType: fileFormat,
      from: inputValue === "" ? "0" : inputValue,
      to: toInputValue === "" ? "0" : toInputValue,
    };

    dispatch(exportHqCustomerLogs(onSuccess, onFailure, stats, searchParam))
      .unwrap()
      .then((data) => {
        if ((data.code = "CVAI0000" && data.data)) {
          onSuccess();
        } else {
          onFailure();
        }
      })
      .catch((er) => {});
  };

  const onSuccess = () => {
    setClosemodel(true);
    return Toast(t("EXPORTSUCC001"), "success");
  };

  const onFailure = () => {
    Toast(t("COMMON000"), "error");
  };

  useEffect(() => {
    loadData(filter, paging);
    loadSetting();
  }, [filter, paging]);

  const loadData = (filter, paging) => {
    dispatch(getCustomers(Object.assign(filter, paging)))
      .unwrap()
      .then((res) => {
        if (res.code === "MSGS4024") {
          setLoading(false);
          setRows(res.data.companies);
          setTotalRecords(res.data.totalCount);
          setPage(res.data.currentPage);
          setTotalPages(res.data.totalPages);
        }
      });
  };

  const loadSetting = () => {
    dispatch(getListSettingsById(companyId))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0000") {
          if (data.data.adminAndDealerDateFormat === "DD-MM-YYYY") {
            setDate("dd-MM-yyyy HH:mm");
          }
          if (data.data.adminAndDealerDateFormat === "MM-DD-YYYY") {
            setDate("MM-dd-yyyy HH:mm");
          }
          if (data.data.adminAndDealerDateFormat === "YYYY-MM-DD") {
            setDate("yyyy-MM-dd HH:mm");
          }
        }
      });
  };

  const handleTextOverflow = (text) => {
    if (text && text.length > 15) {
      return text.substring(0, 14) + "...";
    } else {
      return text;
    }
  };

  const handleViewCustomer = (params) => {
    history.push({
      pathname: "/vis/customerTransactionView",
      state: params,
    });
  };

  const testBackGroundColors = [
    "#C7D4E7",
    "#F8EACD",
    "#DBE1D7",
    "#EBD3E1",
    "#E2DEED",
    "#EBD3D3",
    "#D7EEE8",
    "#D3F5D5",
    "#E5D9C3",
    "#D2C785",
    "#C6E0E3",
    "#E4D8EB",
    "#D0D1DC",
    "#CCE1D8",
    "#CBDAEC",
    "#F6FCE1",
    "#F6FCE1",
    "#DBD0CE",
    "#C3DFCF",
    "#E6D8E5",
    "#C3EBE1",
    "#C0E5F5",
    "#EBE3B1",
    "#F6CFCF",
    "#ECD4E9",
    "#D5F6CF",
    "#DAD9F5",
    "#F2E1CB",
  ];

  const textColors = [
    "#2D4568",
    "#6C5629",
    "#2F4B1C",
    "#491D37",
    "#20163B",
    "#572626",
    "#214C42",
    "#275E2B",
    "#7D6845",
    "#677820",
    "#29666D",
    "#4E2168",
    "#1E203A",
    "#194130",
    "#143F70",
    "#586E0C",
    "#392871",
    "#543935",
    "#395847",
    "#6D3969",
    "#085341",
    "#1E3C4A",
    "#3E380D",
    "#481515",
    "#381434",
    "#163610",
    "#13123E",
    "#30210E",
  ];

  const getAvatarColor = (name) => {
    const colors = [
      "#C7D4E7",
      "#F8EACD",
      "#DBE1D7",
      "#EBD3E1",
      "#E2DEED",
      "#EBD3D3",
      "#D7EEE8",
      "#D3F5D5",
      "#E5D9C3",
      "#D2C785",
      "#C6E0E3",
      "#E4D8EB",
      "#D0D1DC",
      "#CCE1D8",
      "#CBDAEC",
      "#F6FCE1",
      "#F6FCE1",
      "#DBD0CE",
      "#C3DFCF",
      "#E6D8E5",
      "#C3EBE1",
      "#C0E5F5",
      "#EBE3B1",
      "#F6CFCF",
      "#ECD4E9",
      "#D5F6CF",
      "#DAD9F5",
      "#F2E1CB",
    ];
    const index =
      name.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0) %
      colors.length;
    return colors[index];
  };

  const ZoomHandaler = (params) => {
    const { firstName, lastName, imagePreSignedURL } = params.row;

    const getColorIndex = (name) => {
      const total = name
        .toUpperCase()
        .split("")
        .reduce((sum, char) => sum + char.charCodeAt(0), 0);
      return total % testBackGroundColors.length;
    };
    // Get initials
    const initials = `${firstName?.charAt(0) || ""}${lastName?.charAt(0) ||
      ""}`;
    const bgColor = !imagePreSignedURL
      ? getAvatarColor(initials)
      : "transparent";
    const colorIndex = getColorIndex(initials);
    const textColor = imagePreSignedURL ? "inherit" : textColors[colorIndex];

    return (
      <SimpleDialogDemo
        button={
          <Avatar
            style={{
              cursor: "pointer",
              backgroundColor: bgColor,
              color: textColor,
            }}
            alt={firstName}
            src={imagePreSignedURL || undefined}
          >
            {!imagePreSignedURL && initials.toUpperCase()}
          </Avatar>
        }
        child={
          <Avatar
            style={{
              width: "300px",
              height: "300px",
              border: "1px solid #FFFF",
              fontSize: "100px",
              borderRadius: "50%",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: bgColor,
              color: textColor,
            }}
            alt={firstName}
            src={imagePreSignedURL || undefined}
          >
            {!imagePreSignedURL && initials.toUpperCase()}
          </Avatar>
        }
      />
    );
  };

  const columns = React.useMemo(() => [
    {
      field: "company.profile",
      headerName: "",
      sortable: false,
      width: 5,
      renderCell: (params) => {
        return ZoomHandaler(params);
      },
    },

    {
      field: "companyName",
      headerName: t("CUSTDATABLE01"),
      flex: 1,
      minWidth: 190,
      valueGetter: (params) => params.row.name,
      renderCell: (params) => (
        <Tooltip title={`${params.value}`} placement="bottom-start">
          <span>{handleTextOverflow(params.value)}</span>
        </Tooltip>
      ),
    },

    {
      field: "email",
      headerName: t("CUSTDATABLE02"),
      flex: 1,
      minWidth: 190,
      valueGetter: (params) => params.row.email,
      renderCell: (params) => (
        <Tooltip title={`${params.value}`} placement="bottom-start">
          <span>{handleTextOverflow(params.value)}</span>
        </Tooltip>
      ),
    },

    {
      field: "mobile",
      headerName: t("CUSTDATABLE03"),
      flex: 1,
      minWidth: 190,
      valueGetter: (params) => params.row.phone,
      renderCell: (params) => (
        <Tooltip title={`${params.value}`} placement="bottom-start">
          <span>{handleTextOverflow(params.value)}</span>
        </Tooltip>
      ),
    },

    {
      field: "Subscription",
      headerName: t("CUSTDATABLE05"),
      flex: 1,
      minWidth: 190,
      valueGetter: (params) => params.row.subscriptionName,
      renderCell: (params) => (
        <Tooltip title={`${params.value}`} placement="bottom-start">
          <span>{handleTextOverflow(params.value)}</span>
        </Tooltip>
      ),
    },

    {
      field: "billingCycle",
      headerName: t("CUSTDATABLE14"),
      flex: 1,
      minWidth: 190,
      valueGetter: (params) => params.row.billingCycle,
      renderCell: (params) => (
        <Tooltip title={`${params.value}`} placement="bottom-start">
          <span>{handleTextOverflow(params.value)}</span>
        </Tooltip>
      ),
    },

    {
      field: "planBasePrice",
      headerName: t("CUSTDATABLE20"),
      flex: 1,
      minWidth: 190,
      valueGetter: (params) => params.row.planBasePrice / 100,
      renderCell: (params) => (
        <Tooltip title={`${params.value}`} placement="bottom-start">
          <span>{handleTextOverflow(params.value)}</span>
        </Tooltip>
      ),
    },
    {
      field: "DealerName",
      headerName: t("CUSTDATABLE22"),
      flex: 1,
      minWidth: 140,
      valueGetter: (params) => params.row.dealerName,
      renderCell: (params) => (
        <Tooltip title={`${params.value}`} placement="bottom-start">
          <span>{handleTextOverflow(params.value)}</span>
        </Tooltip>
      ),
    },

    {
      field: "Actions",
      headerName: t("CUSTDATABLE16"),
      type: "actions",
      flex: 1,
      minWidth: 165,
      width: 150,
      headerAlign: "center",
      getActions: (params) => [
        <GridActionsCellItem
          icon={<ViewIcon />}
          onClick={() => handleViewCustomer(params.row)}
        />,
      ],
    },
  ]);

  const handleFilterIcon = () => {
    setOpenFilter(true);
  };

  const handleDownload = () => {
    if (rows.length === 0) {
      Toast(t("dataTableEmptyList"), "error");
      return;
    } else {
      setOpenDownload(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      {/* <HeaderToolbar title={t("CUSTDATABLE10")} /> */}

      <Box
        display={"flex"}
        width={"100%"}
        flexDirection={"row-reverse"}
        alignItems={"center"}
        style={{ marginLeft: "20px" }}
      >
        <Box item>
          {clear && (
            <Link
              href="#"
              underline="hover"
              className="line"
              style={{
                opacity: "0.8",
                color: "#E3393C",
                fontSize: "14px",
                underline: "hover",
                display: "inline",
              }}
              onClick={resetFilter}
            >
              {t("CLEARFILTER")}
            </Link>
          )}
        </Box>

        <Box item style={{ margin: "0 8px" }}>
          <Tooltip title={t("ADD036")} onClick={handleFilterIcon}>
            <img src={filterIcon} />
          </Tooltip>
        </Box>

        <Box item style={{ margin: "0 8px" }}>
          {/* <Tooltip title={t("ADD037")} onClick={handleDownload}>
            <img src={forwardIcon} />
          </Tooltip> */}
          <ExportDialog
            rowsPerPage={rowsPerPage}
            applyFilter={(data) => handleExportCustomer(data)}
            totalRecords={totalRecords}
            nameTitle={"Export Customer Transaction Details"}
            handleFileFormatChange={handleFileFormatChange}
            handleDataRecordsChange={handleDataRecordsChange}
            handleInputChange={handleInputChange}
            handleToInputChange={handleToInputChange}
            fileFormat={fileFormat}
            noOfRecords={noOfRecords}
            inputValue={inputValue}
            toInputValue={toInputValue}
            setFileFormat={setFileFormat}
            setNoOfRecords={setNoOfRecords}
            setInputValue={setInputValue}
            setToInputValue={setToInputValue}
            setIsLivePhoto={setIsLivePhoto}
            setIsSignature={setIsSignature}
            isLivePhoto={isLivePhoto}
            isSignature={isSignature}
            handleCheckBoxLivePhoto={handleCheckBoxLivePhoto}
            handleCheckBoxSignature={handleCheckBoxSignature}
            dealerPortal={true}
            closemodel={closemodel}
            setClosemodel={setClosemodel}
          />
        </Box>

        <Box item>
          <Search
            onSearch={(e) => globalsearch(e)}
            clearSearch={() => loadData(filter, paging)}
          />
        </Box>
      </Box>

      <div style={{ height: 300, width: "100%", marginTop: "15px" }}>
        <DataTableLatest
          columns={columns}
          rows={rows}
          page={page}
          transactions={true}
          count={totalRecords}
          rowId={(row) => row.id}
          pageCount={totalPages}
          pageSize={rowsPerPage}
          handleChange={(newPage, size) => handleChange(newPage, size)}
        />
      </div>

      {openFilter && (
        <CustomerAndDealerTranscationFilter
          open={openFilter}
          onClose={() => {
            setOpenFilter(false);
          }}
          applyFilter={handleFilter}
          date={date}
        />
      )}

      {/* {openDownload && (
        <CustomerTransactionAndReportExports
          open={openDownload}
          handleClose={() => {
            setOpenDownload(false);
          }}
          type={customerTransaction}
          filter={filter}
        />
      )} */}
    </>
  );
}
export default CustomersTransaction;
